import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { InfoBaseIcon } from '../../icons';
import {
	NoteBox,
	NoteIcon,
	NoteText,
} from '../PersonalDetailsForm/NameChangeNote.styles';

/**
 * Note shown in the registration "Personal details" form warning the user that
 * their name cannot be changed after registration (their tickets are issued to
 * it). Rendered directly under the name fields. Reuses the profile
 * NameChangeNote's box/icon/text (same Figma design tokens); unlike the profile
 * note there is no support link — the name is still editable here.
 */
export const NameChangeIrreversibleNote: FC = () => {
	const { t } = useTranslation('personalDetails');

	return (
		<NoteBox data-testid="personal-detailsFormV2-nameChange-note">
			<NoteIcon>
				<InfoBaseIcon />
			</NoteIcon>
			<NoteText>{t('text.name_change_irreversible')}</NoteText>
		</NoteBox>
	);
};
